<script setup>
const config = useRuntimeConfig();
const props = defineProps({
  text: String,
  textColor: String,
  button: Object,
});
</script>

<template>
  <div
    v-html="text"
    class="prose px-md lg:px-lg xl:px-xl mb-xl last:mb-0 prose--max-w"
    :class="textColor === 'dark' ? 'prose--black' : ''"
  ></div>
  <div
    v-if="button.text && button.url"
    class="px-md lg:px-lg xl:px-xl mb-xl last:mb-0"
  >
    <Button
      type="link"
      :href="
        button.type === 'linkInternal'
          ? config.public.appBaseUrl + button.url
          : button.url
      "
      :text="button.text"
      :target="button.target"
      :icon="true"
      :aria-label="button.ariaLabel"
      :color="button.color"
      icon-position="right"
    />
  </div>
</template>

<style></style>
